import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutFuelDetailReport extends Layout {
    sourceFuelDetail: DataSource;
    textboxCardProvider: Textbox;
    textboxDates: Textbox;
}
